var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"buy-number rai-data"},[(!_vm.hidePrefix)?_c('span',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }